export const businessChannelNames = (businessId)=>({
        businessId,
        mgmt: "private-".concat(businessId),
        scout: "private-".concat(businessId, "-scout")
    });
